import styled from 'styled-components';
import { Content as BaseContent } from '../../CommonComponents/OPL/StickyFooter/StickyFooter';

export const Content = styled(BaseContent)({
  maxWidth: 1200,
  width: '100%',
  padding: '0 30px',
  margin: '32px auto',
  boxSizing: 'border-box',
});
